<template>
  <div>
    <w-loader v-if="user.loading"/>
    <div class="widget-holder h-100 w-100" ref="widget_container" data-test-id="iotum-widget"></div>
  </div>
</template>
<script>
  import { Dashboard, Service } from '@iotum/callbridge-js';
  import { vueComponent } from '../../../../libs/helpers2';
  import l from '../../../../libs/lang';
  import VideoUser from '../../../../models/VideoUser';

  export default {
    data() {
      return {
        l,
        user: new VideoUser(this.$session, vueComponent(this)),
        widget: null,
        tomorrow: new Date(),
      };
    },
    async mounted() {
      this.tomorrow.setDate(this.tomorrow.getDate() + 2);
      if (this.$route.params.id) {
        await this.$data.user.getItem(this.$route.params.id);
        await this.$data.user.getVideoToken();
        this.showWidget();
      }
    },
    methods: {
      showWidget() {
        const url = new URL(this.$data.user.item.meeting_url);
        this.$data.widget = new Dashboard(
          {
            container: this.$refs.widget_container,
            domain: url.host,
            sso: {
              hostId: this.$data.user.token.host_id,
              token: this.$data.user.token.token
            }
          },
          Service.Search,
          // {
          //   layout: LayoutOption.main,
          //   pathname: 'past'
          // }
        );
        window.widget = this.$data.widget;
        this.$data.widget.on('dashboard.READY', () => {
          this.$data.widget.search(`before:${this.tomorrow.toISOString().split('T')[0]}`);
        });
        console.log('Showing widget for user:', this.$data.user.item);
      }
    },
  };
</script>

<style scoped>
.widget-holder {
  height: 74vh;
}
</style>
